import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EASE = [0.16, 1, 0.3, 1];

export default function LiveSpotlight() {
  const [live, setLive] = useState(null);

  useEffect(() => {
    let active = true;
    if (new URLSearchParams(window.location.search).has("demolive")) {
      setLive({
        platform: "twitch",
        isLive: true,
        title: "LIVE — Crypto degen plays & casino streams",
        viewerCount: 1234,
        thumbnailUrl:
          "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=1280&q=60",
        watchUrl: "https://www.twitch.tv/tezzo100x",
        channelName: "tezzo100x",
      });
      return;
    }
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/live-status`);
        if (active) setLive(data.winner || null);
      } catch (e) {
        if (active) setLive(null);
      }
    };
    load();
    const id = setInterval(load, 60000);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, []);

  return (
    <AnimatePresence>
      {live && (
        <motion.div
          data-testid="live-spotlight"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="overflow-hidden border-b border-white/15"
        >
          <a
            data-testid="live-spotlight-link"
            href={live.watchUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group block max-w-7xl mx-auto w-full px-4 sm:px-6 py-4"
          >
            <div className="flex flex-col md:flex-row items-stretch gap-4 border border-white/15 bg-black overflow-hidden">
              <div className="relative md:w-[360px] shrink-0 aspect-video overflow-hidden">
                {live.thumbnailUrl && (
                  <img
                    src={live.thumbnailUrl}
                    alt={live.title || "Live"}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                )}
                <div className="absolute top-2 left-2 flex items-center gap-2 bg-white text-black px-2 py-1">
                  <span className="w-2 h-2 bg-black rounded-full live-dot" />
                  <span className="font-sync text-[10px] tracking-[0.25em] uppercase font-bold">Live</span>
                </div>
              </div>

              <div className="flex-1 flex items-center justify-between gap-4 p-5">
                <div className="min-w-0">
                  <p className="font-sync text-[10px] tracking-[0.3em] uppercase text-white/50">
                    Live on {live.platform} {live.channelName ? `· ${live.channelName}` : ""}
                  </p>
                  <p className="font-mono-t text-base md:text-lg text-white mt-1 truncate">
                    {live.title || "Streaming now"}
                  </p>
                  {typeof live.viewerCount === "number" && (
                    <p className="font-mono-t text-xs text-white/40 mt-1">
                      {live.viewerCount.toLocaleString()} watching
                    </p>
                  )}
                </div>
                <span className="shrink-0 flex items-center gap-3 font-sync text-xs tracking-[0.3em] uppercase text-white/80">
                  Watch
                  <span className="w-10 h-10 border border-white/40 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-colors duration-200">
                    <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-200" strokeWidth={1.5} />
                  </span>
                </span>
              </div>
            </div>
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
